// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

html {
  scroll-behavior: smooth;
}
body{
  font-family: 'Quicksand', sans-serif;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

img {
  display: block;
}

main{
  flex-grow: 1;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;

  box-sizing: border-box;
}
.skip-link {
  position: absolute;
  top: 50;
  left: 0;
  padding: 8px;
  background-color: #bf1722;
  color: white;
  z-index: 100;
}
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background-color: #bf1722;
  color: white;
  padding: 8px;
  z-index: 100;
}
 
.skip-link:focus {
   top: 0;
}


/* NO CONNECTION START*/
.no-connection {
  text-align: center;
  margin: 20px 0;
}

.no-connection img {
  width: 100%;
  max-width: 300px;
  height: auto;
  margin: 0 auto;
  display: block;
}

.no-connection p {
  font-size: 16px;
  color: #333;
  margin-top: 10px;
}
/* NO CONNECTION END */

/* NO DATA START */
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 50px; 
}

.no-data img {
  width: 100%;
  max-width: 300px;
  height: auto;
  margin: 0 auto;
  display: block;
}

.no-data p {
  font-size: 16px;
  color: #333;
  margin-top: 10px;
}
/* NO DATA END */

/* LIKE START */
.like {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #db0000;
  
  position: fixed;
  bottom: 16px;
  right: 16px;
  border-radius: 50%;
  border: 0;
  
  font-size: 18px;
  color: white;
  cursor: pointer;
}
/* LIKE END */

/* HEADER START */

header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

#hamburgerButton {
  display: none;
}


.logo {
  flex: 1;
  font-size: 24px;
  font-weight: bold;
}

/* navigation */
nav button {
  min-width: 44px;
  min-height: 44px;

  display: inline-block;
}
nav ul{
  display: flex;
  align-items: center;

  
  list-style: none;

  padding: 20px 0px;
  margin: 0;
}

nav li{
  flex-grow: 1;
  margin: 10px;
}

nav a {
  font-size: 18px;
  font-weight: 500;
  box-sizing: border-box;

  text-align: center;
  display:block;
  min-width: 44px;
  min-height: 44px;
  padding: 10px 20px;

  color: black;
  text-decoration: none; 
  
  transition: color 0.3s;
}


nav li a:hover {
  color: #f1c40f;
}

.contact-info {
  font-size: 18px;
  font-weight: 700;

  flex: 1;
  text-align: right;
}

/* HEADER END */


/* HERO START */
.hero {
  position: relative;
}

.hero-text {
  position: absolute;
  top: 50%; 
  left: 50%; 
  transform: translate(-50%, -50%); 
  text-align: center; 
  color: white; 

  background-color: rgba(0, 0, 0, 0.8);
  padding: 20px;
}

.hero-text h1 {
  font-size: 3rem; 
  margin-bottom: 10px; 
}

.hero-text p {
  font-size: 1.5rem; 
}

.hero-text .explore-now-cta {
  display: inline-block; 
  padding: 10px 20px; 
  background-color: #f1c40f; 
  color: black; 
  text-decoration: none; 
  font-weight: bold; 
  border-radius: 5px;
  transition: background-color 0.3s; 

  box-sizing: border-box;
  min-width: 44px;
  min-height: 44px;
}

.hero-text .explore-now-cta:hover {
  background-color: #f39c12; 
}

.hero-image img{
  width:100%;
  height:100vh;
  object-fit: cover;
}

/* HERO END */

/* EXPLORE START */
.explore {
  text-align: center;
}
.explore-text {


  margin-top: 50px;
  cursor: pointer;

  text-align: center;
  font-size: 30px;
  font-weight: 700;
  text-decoration: underline; 
}

.explore-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;

  justify-items: center; 
  align-items: center;
  margin-top: 50px;
}

.explore-item {
  position: relative;
  width: 350px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  margin-bottom: 20px;
  justify-items: center;

  cursor: pointer;
}

.explore-item:hover {
  transform: translateY(-5px);
}

.rating {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 10px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.explore-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.explore-item .card{
  padding: 8px;

}

.explore-item .card .details {
  padding: 25px;
}

.explore-item .card .city {
  font-size: 16px;
  font-style: italic;

}

.explore-item .card h3.name {
  font-size: 20px;
  margin-bottom: 5px;
}

.explore-item a {
  text-decoration: none;
  color: #333; /* Opsional: menetapkan warna tautan yang sesuai */
}

.explore-item .card .description {
  font-size: 16px;
  margin-bottom: 0;
  text-align: justify;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}


/* EXPLORE END */


/* FOOTER START */
/* Footer */
/* Footer */
footer {
  background-color: #f1f1f1;
  padding: 20px 0;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-navigation ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-navigation ul li {
  display: inline;
  margin-right: 20px;
}

.footer-navigation ul li:last-child {
  margin-right: 0;
}

.footer-navigation ul li a {
  text-decoration: none;
  color: #333;

  transition: color 0.3s;
}

.footer-navigation ul li a:hover {
  color: #f1c40f;
}

.footer-text p {
  font-size: 14px;
}


/* FOOTER END */


/* DETAIL PAGE START */
.kembali{
  margin-bottom: 5px;
}
.kembali a {
  text-decoration: none;
  color: black; /* Atur warna teks tautan sesuai kebutuhan */
  font-size: 18px;
  line-height: 44px;

  display: inline-block; 
  min-width: 44px;
  min-height: 44px;
}

.kembali a:hover {
  color: #f39c12;
  transition: color 0.3s;
}

.restaurant-info {
  display: flex;
}

.restaurant-image {
  flex: 1;
  margin-right: 20px;
}

.restaurant-image img {
  width: 100%;
  height: auto;

  border-radius: 5px;
}

.restaurant-details {
  flex: 2;
}

.restaurant-menu {
  display: flex;
  margin-top: 20px;
}

.restaurant-description{
  text-align: justify;
}

.food-menu,
.drink-menu {
  flex: 1;
  margin-right: 20px;
}
/* Form review start */
.add-review {
  padding: 20px;
}

.add-review h2 {
  margin-bottom: 10px;
}

.add-review label {
  display: block;
  margin-bottom: 5px;
}


.add-review textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 100px;
}

.add-review input[type="text"] {
  width: 100%;
  border: 1px solid #ccc;
  height: 44px;
}

.add-review button[type="submit"] {
  font-size: 16px;
  width: 100px;
  height: 44px;
  background-color: #f1c40f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;


  display: block;
  margin: 0 auto;
}

.add-review button[type="submit"]:hover {
  background-color: #d4ac0d; /* Lighter shade on hover */
}

/* Form review end */

/* Customer review start */
.customer-reviews {
  margin-top: 20px;
}

.review-wrapper{
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, 1fr);
}

.review {
  margin-bottom: 10px;
}

.customer-reviews {
  padding: 20px;
}

.review-card {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.review-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
}

.customer-info {
  flex: 1;
}

.customer-name {
  font-weight: bold;
  margin: 0;
}

.rating {
  margin: 0;
}

.review-text {
  margin: 0;
}
/* Customer review start */


/* DETAIL PAGE END */`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":";;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;;EAEf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;GACG,MAAM;AACT;;;AAGA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA,sBAAsB;;AAEtB,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA,gBAAgB;;AAEhB,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;;EAEzB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;;EAET,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;AACA,aAAa;;AAEb,iBAAiB;;AAEjB;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;AAErB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;;EAEhB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;;;EAGnB,gBAAgB;;EAEhB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;;EAEtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,YAAY;EACZ,qBAAqB;;EAErB,sBAAsB;AACxB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,OAAO;EACP,iBAAiB;AACnB;;AAEA,eAAe;;;AAGf,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;;EAEZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;;EAEjC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA,aAAa;;AAEb,kBAAkB;AAClB;EACE,kBAAkB;AACpB;AACA;;;EAGE,gBAAgB;EAChB,eAAe;;EAEf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;;EAEd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;;EAErB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW,EAAE,kDAAkD;AACjE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;;EAEnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;;AAGA,gBAAgB;;;AAGhB,iBAAiB;AACjB,WAAW;AACX,WAAW;AACX;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;;EAEX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;AAGA,eAAe;;;AAGf,sBAAsB;AACtB;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY,EAAE,4CAA4C;EAC1D,eAAe;EACf,iBAAiB;;EAEjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,kBAAkB;AACpB;AACA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;;;EAGf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,oBAAoB;;AAEpB,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;AACA,0BAA0B;;;AAG1B,oBAAoB","sourcesContent":["\n\nhtml {\n  scroll-behavior: smooth;\n}\nbody{\n  font-family: 'Quicksand', sans-serif;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\nimg {\n  display: block;\n}\n\nmain{\n  flex-grow: 1;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 20px;\n\n  box-sizing: border-box;\n}\n.skip-link {\n  position: absolute;\n  top: 50;\n  left: 0;\n  padding: 8px;\n  background-color: #bf1722;\n  color: white;\n  z-index: 100;\n}\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background-color: #bf1722;\n  color: white;\n  padding: 8px;\n  z-index: 100;\n}\n \n.skip-link:focus {\n   top: 0;\n}\n\n\n/* NO CONNECTION START*/\n.no-connection {\n  text-align: center;\n  margin: 20px 0;\n}\n\n.no-connection img {\n  width: 100%;\n  max-width: 300px;\n  height: auto;\n  margin: 0 auto;\n  display: block;\n}\n\n.no-connection p {\n  font-size: 16px;\n  color: #333;\n  margin-top: 10px;\n}\n/* NO CONNECTION END */\n\n/* NO DATA START */\n.no-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin-top: 50px; \n}\n\n.no-data img {\n  width: 100%;\n  max-width: 300px;\n  height: auto;\n  margin: 0 auto;\n  display: block;\n}\n\n.no-data p {\n  font-size: 16px;\n  color: #333;\n  margin-top: 10px;\n}\n/* NO DATA END */\n\n/* LIKE START */\n.like {\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #db0000;\n  \n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  border-radius: 50%;\n  border: 0;\n  \n  font-size: 18px;\n  color: white;\n  cursor: pointer;\n}\n/* LIKE END */\n\n/* HEADER START */\n\nheader {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n}\n\n#hamburgerButton {\n  display: none;\n}\n\n\n.logo {\n  flex: 1;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n/* navigation */\nnav button {\n  min-width: 44px;\n  min-height: 44px;\n\n  display: inline-block;\n}\nnav ul{\n  display: flex;\n  align-items: center;\n\n  \n  list-style: none;\n\n  padding: 20px 0px;\n  margin: 0;\n}\n\nnav li{\n  flex-grow: 1;\n  margin: 10px;\n}\n\nnav a {\n  font-size: 18px;\n  font-weight: 500;\n  box-sizing: border-box;\n\n  text-align: center;\n  display:block;\n  min-width: 44px;\n  min-height: 44px;\n  padding: 10px 20px;\n\n  color: black;\n  text-decoration: none; \n  \n  transition: color 0.3s;\n}\n\n\nnav li a:hover {\n  color: #f1c40f;\n}\n\n.contact-info {\n  font-size: 18px;\n  font-weight: 700;\n\n  flex: 1;\n  text-align: right;\n}\n\n/* HEADER END */\n\n\n/* HERO START */\n.hero {\n  position: relative;\n}\n\n.hero-text {\n  position: absolute;\n  top: 50%; \n  left: 50%; \n  transform: translate(-50%, -50%); \n  text-align: center; \n  color: white; \n\n  background-color: rgba(0, 0, 0, 0.8);\n  padding: 20px;\n}\n\n.hero-text h1 {\n  font-size: 3rem; \n  margin-bottom: 10px; \n}\n\n.hero-text p {\n  font-size: 1.5rem; \n}\n\n.hero-text .explore-now-cta {\n  display: inline-block; \n  padding: 10px 20px; \n  background-color: #f1c40f; \n  color: black; \n  text-decoration: none; \n  font-weight: bold; \n  border-radius: 5px;\n  transition: background-color 0.3s; \n\n  box-sizing: border-box;\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.hero-text .explore-now-cta:hover {\n  background-color: #f39c12; \n}\n\n.hero-image img{\n  width:100%;\n  height:100vh;\n  object-fit: cover;\n}\n\n/* HERO END */\n\n/* EXPLORE START */\n.explore {\n  text-align: center;\n}\n.explore-text {\n\n\n  margin-top: 50px;\n  cursor: pointer;\n\n  text-align: center;\n  font-size: 30px;\n  font-weight: 700;\n  text-decoration: underline; \n}\n\n.explore-content {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 10px;\n\n  justify-items: center; \n  align-items: center;\n  margin-top: 50px;\n}\n\n.explore-item {\n  position: relative;\n  width: 350px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  overflow: hidden;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n  margin-bottom: 20px;\n  justify-items: center;\n\n  cursor: pointer;\n}\n\n.explore-item:hover {\n  transform: translateY(-5px);\n}\n\n.rating {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  padding: 5px 10px;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 5px;\n  font-size: 20px;\n  font-weight: bold;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.explore-item img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.explore-item .card{\n  padding: 8px;\n\n}\n\n.explore-item .card .details {\n  padding: 25px;\n}\n\n.explore-item .card .city {\n  font-size: 16px;\n  font-style: italic;\n\n}\n\n.explore-item .card h3.name {\n  font-size: 20px;\n  margin-bottom: 5px;\n}\n\n.explore-item a {\n  text-decoration: none;\n  color: #333; /* Opsional: menetapkan warna tautan yang sesuai */\n}\n\n.explore-item .card .description {\n  font-size: 16px;\n  margin-bottom: 0;\n  text-align: justify;\n\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n\n/* EXPLORE END */\n\n\n/* FOOTER START */\n/* Footer */\n/* Footer */\nfooter {\n  background-color: #f1f1f1;\n  padding: 20px 0;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer-navigation ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-navigation ul li {\n  display: inline;\n  margin-right: 20px;\n}\n\n.footer-navigation ul li:last-child {\n  margin-right: 0;\n}\n\n.footer-navigation ul li a {\n  text-decoration: none;\n  color: #333;\n\n  transition: color 0.3s;\n}\n\n.footer-navigation ul li a:hover {\n  color: #f1c40f;\n}\n\n.footer-text p {\n  font-size: 14px;\n}\n\n\n/* FOOTER END */\n\n\n/* DETAIL PAGE START */\n.kembali{\n  margin-bottom: 5px;\n}\n.kembali a {\n  text-decoration: none;\n  color: black; /* Atur warna teks tautan sesuai kebutuhan */\n  font-size: 18px;\n  line-height: 44px;\n\n  display: inline-block; \n  min-width: 44px;\n  min-height: 44px;\n}\n\n.kembali a:hover {\n  color: #f39c12;\n  transition: color 0.3s;\n}\n\n.restaurant-info {\n  display: flex;\n}\n\n.restaurant-image {\n  flex: 1;\n  margin-right: 20px;\n}\n\n.restaurant-image img {\n  width: 100%;\n  height: auto;\n\n  border-radius: 5px;\n}\n\n.restaurant-details {\n  flex: 2;\n}\n\n.restaurant-menu {\n  display: flex;\n  margin-top: 20px;\n}\n\n.restaurant-description{\n  text-align: justify;\n}\n\n.food-menu,\n.drink-menu {\n  flex: 1;\n  margin-right: 20px;\n}\n/* Form review start */\n.add-review {\n  padding: 20px;\n}\n\n.add-review h2 {\n  margin-bottom: 10px;\n}\n\n.add-review label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n\n.add-review textarea {\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  height: 100px;\n}\n\n.add-review input[type=\"text\"] {\n  width: 100%;\n  border: 1px solid #ccc;\n  height: 44px;\n}\n\n.add-review button[type=\"submit\"] {\n  font-size: 16px;\n  width: 100px;\n  height: 44px;\n  background-color: #f1c40f;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n\n\n  display: block;\n  margin: 0 auto;\n}\n\n.add-review button[type=\"submit\"]:hover {\n  background-color: #d4ac0d; /* Lighter shade on hover */\n}\n\n/* Form review end */\n\n/* Customer review start */\n.customer-reviews {\n  margin-top: 20px;\n}\n\n.review-wrapper{\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.review {\n  margin-bottom: 10px;\n}\n\n.customer-reviews {\n  padding: 20px;\n}\n\n.review-card {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.review-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 15px;\n}\n\n.customer-info {\n  flex: 1;\n}\n\n.customer-name {\n  font-weight: bold;\n  margin: 0;\n}\n\n.rating {\n  margin: 0;\n}\n\n.review-text {\n  margin: 0;\n}\n/* Customer review start */\n\n\n/* DETAIL PAGE END */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
